interface EnvironmentConfig {
  production: boolean;
  baseUrl: string;
  prefix: string;
  ssoAuthorizeUrl: string;
  oauthTokenUrl: string;
  tenant_id: string;
  clientId: string;
  redirectUri: string;
  IdleUserLogoutTime: number;
  oauthClientId: string;
  oauthClientSecret: string;
}

const environmentOverrides: Record<string, Partial<EnvironmentConfig>> = {
  dev: {
    production: false,
    baseUrl: 'https://api.c4fai9-johnsonan7-d1-public.model-t.cc.commerce.ondemand.com/',
    prefix: '/occ/v2/',
    ssoAuthorizeUrl: 'https://api.c4fai9-johnsonan7-d1-public.model-t.cc.commerce.ondemand.com/occ/v2/chimeagent/agent/authorize',
    oauthTokenUrl: 'https://api.c4fai9-johnsonan7-d1-public.model-t.cc.commerce.ondemand.com/authorizationserver/oauth/token',
    tenant_id: '3ac94b33-9135-4821-9502-eafda6592a35',
    clientId: '5b1135aa-7be5-48ac-abe9-22472bbcb391',
    redirectUri: 'https://agent-dev1.jjcustomerconnect.com/sso/login',
    IdleUserLogoutTime: 1080,
    oauthClientId: 'JJSV_Client1',
    oauthClientSecret: 'secret',
  },
  stage1: {
    production: false,
    baseUrl: 'https://api.c4fai9-johnsonan7-s1-public.model-t.cc.commerce.ondemand.com/',
    prefix: '/occ/v2/',
    ssoAuthorizeUrl: 'https://api.c4fai9-johnsonan7-s1-public.model-t.cc.commerce.ondemand.com/occ/v2/chimeagent/agent/authorize',
    oauthTokenUrl: 'https://api.c4fai9-johnsonan7-s1-public.model-t.cc.commerce.ondemand.com/authorizationserver/oauth/token',
    tenant_id: '3ac94b33-9135-4821-9502-eafda6592a35',
    clientId: '78691b76-af2d-4661-a19f-27e694ffc3ba',
    redirectUri: 'https://agent-stage1.jjcustomerconnect.com/sso/login',
    IdleUserLogoutTime: 900,
    oauthClientId: 'JJSV_Client1',
    oauthClientSecret: 'secret',
  },
  stage2: {
    production: false,
    baseUrl: 'https://api.c4fai9-johnsonan7-s2-public.model-t.cc.commerce.ondemand.com/',
    prefix: '/occ/v2/',
    ssoAuthorizeUrl: 'https://api.c4fai9-johnsonan7-s2-public.model-t.cc.commerce.ondemand.com/occ/v2/chimeagent/agent/authorize',
    oauthTokenUrl: 'https://api.c4fai9-johnsonan7-s2-public.model-t.cc.commerce.ondemand.com/authorizationserver/oauth/token',
    tenant_id: '3ac94b33-9135-4821-9502-eafda6592a35',
    clientId: '4bfdabed-3d94-4bb3-a5c2-2aca34b64bfe',
    redirectUri: 'https://agent-stage2.jjcustomerconnect.com/sso/login',
    IdleUserLogoutTime: 900,
    oauthClientId: 'JJSV_Client1',
    oauthClientSecret: 'secret',
  },
  prod:  {
    production: true,
    baseUrl: 'https://api.c4fai9-johnsonan7-p1-public.model-t.cc.commerce.ondemand.com/',
    prefix: '/occ/v2/',
    ssoAuthorizeUrl: 'https://api.c4fai9-johnsonan7-p1-public.model-t.cc.commerce.ondemand.com/occ/v2/chimeagent/agent/authorize',
    oauthTokenUrl: 'https://api.c4fai9-johnsonan7-p1-public.model-t.cc.commerce.ondemand.com/authorizationserver/oauth/token',
    tenant_id: '3ac94b33-9135-4821-9502-eafda6592a35',
    clientId: 'd471517d-158c-43ed-8112-cbf41165d771',
    redirectUri: 'https://agent.jjcustomerconnect.com/sso/login',
    IdleUserLogoutTime: 900,
    oauthClientId: 'JJSV_Client',
    oauthClientSecret: 'Agent@2026!Hy',
  },
};

const hostname = globalThis.location.hostname.toLowerCase();

const localConfig: Partial<EnvironmentConfig> = {
  production: false,
  baseUrl: 'https://sv-local.jjcustomerconnect.com:9002/',
  prefix: '/occ/v2/',
  ssoAuthorizeUrl: 'https://sv-local.jjcustomerconnect.com:9002/occ/v2/chimeagent/agent/authorize',
  oauthTokenUrl: 'https://sv-local.jjcustomerconnect.com:9002/authorizationserver/oauth/token',
  tenant_id: '3ac94b33-9135-4821-9502-eafda6592a35',
  clientId: '7ffadf87-395d-449c-91dd-24c8bcf06501',
  redirectUri: 'https://localhost:4200/sso/login',
  IdleUserLogoutTime: 900,
  oauthClientId: 'JJSV_Client1',
  oauthClientSecret: 'secret',
};

let selectedOverrides: Partial<EnvironmentConfig> | undefined;

if (hostname === 'agent.jjcustomerconnect.com') {
  selectedOverrides = environmentOverrides['prod'];
} else if (hostname === 'agent-stage2.jjcustomerconnect.com') {
  selectedOverrides = environmentOverrides['stage2'];
} else if (hostname === 'agent-stage1.jjcustomerconnect.com') {
  selectedOverrides = environmentOverrides['stage1'];
} else if (hostname === 'agent-dev1.jjcustomerconnect.com') {
  selectedOverrides = environmentOverrides['dev'];
} else if (hostname === 'localhost' || hostname === '127.0.0.1') {
  selectedOverrides = localConfig;
}

if (!selectedOverrides) {
  throw new Error(
    `No environment configuration found for hostname: ${hostname}`
  );
}

export const environment: EnvironmentConfig = {
  ...selectedOverrides,
} as EnvironmentConfig;